module.exports = __webpack_public_path__ + "static/media/captura-de-pantalla-2012-08-22-a-las-10-16-27.b7f50396.png";